import { PropsWithChildren } from 'react';
import { useResizablePanel } from '@dealstack/frontend/shared/layout/DashboardGrid/SidePanels/utils.ts';
import {
	DashboardSidePanelContainer,
	SidePanelResizer,
} from '@dealstack/frontend/shared/layout/DashboardGrid/SidePanels/styled.tsx';
import { Flex } from '@mantine/core';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	isOpened: boolean;
	allowResizing?: boolean;
}

export const RightPanel = ({ isOpened, allowResizing, children }: PropsWithChildren<Props>) => {
	const { width, handleMouseDown, isResizing } = useResizablePanel({ side: 'right' });

	return (
		<DashboardSidePanelContainer
			data-testid={TEST_ELEMENT_IDS.RIGHT_PANEL}
			$isSidePanelOpen={isOpened}
			$width={width}
			$isResizing={isResizing.current}
			$allowResizing={allowResizing}
			role="complementary"
			$side="right"
		>
			{children && (
				<>
					<Flex direction="column" p="1rem" h="100%">
						{children}
					</Flex>
					{allowResizing && (
						<SidePanelResizer
							onMouseDown={(e) => {
								e.preventDefault(); // disable text selection
								handleMouseDown();
							}}
							role="separator"
							side="right"
						/>
					)}
				</>
			)}
		</DashboardSidePanelContainer>
	);
};
